import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/stelvaga.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import React from "react";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";

export const PersonStelvaga = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}><IntlMessage id={'team.person.stelvaga.fullName'} /></MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        <IntlMessage id={'team.person.stelvaga.title'} />
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <MyText strong size={"small"}><IntlMessage id={'team.label.workplace'} /></MyText>
                    <MyText><IntlMessage id={'team.person.stelvaga.workplace'} /></MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.label.roleInProject'} /></MyText>
                <MyText size={"small"} italic><IntlMessage id={'team.person.stelvaga.role'} /></MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.label.projects'} /></MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - <IntlMessage id={'team.person.stelvaga.projects.1'} />
                </MyText>
            </Flex>
        </Flex>
    );
};
